var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurvedSection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 100,
    viewBox: "0 0 1440 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1440 99.9998L1440 0.000160217L4.85593e-06 -6.64245e-05L0 100C146.685 58.8115 414.246 31.2489 720.001 31.249C1025.75 31.249 1293.31 58.8115 1440 99.9998Z",
    fill: "#18181B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurvedSection);
export default __webpack_public_path__ + "static/media/curved-section.3bba70be9f8daa3e9d3569309da036bd.svg";
export { ForwardRef as ReactComponent };